import { ContentNotAvailable, ProgressCircle } from "@equiem/web-ng-lib";
import React from "react";
import { withAppContexts } from "../../contexts/withAppContexts";
import { usePublicContentUuidQuery } from "../../generated/gateway-client";
import { ContentRedirect } from "../ContentRedirect";

interface Props {
  id: string;
}

export const ShareableRedirect: React.FC<Props> = ({ id }) => {
  const { loading, data } = usePublicContentUuidQuery({
    variables: { shareableLinkId: id },
  });

  if (loading) {
    return (
      <div className="text-center py-3">
        <ProgressCircle size="lg" />
      </div>
    );
  }

  if (data?.publicContentView.__typename == null) {
    return <ContentNotAvailable />;
  }

  if (data?.publicContentView.node?.uuid == null) {
    return <ContentNotAvailable />;
  }

  const { uuid } = data?.publicContentView?.node;

  return <ContentRedirect uuid={uuid} />;
};

export default withAppContexts(ShareableRedirect, {
  skipMetrics: true,
});
